import React from 'react';
import { TableCell, TableSortLabel } from '@mui/material';

const SortableTableHeader = ({ 
  field, 
  label, 
  sortField, 
  sortDirection, 
  onSort, 
  sortable = true,
  ...props 
}) => {
  const handleSort = () => {
    if (sortable) {
      const newDirection = sortField === field && sortDirection === 'asc' ? 'desc' : 'asc';
      onSort(field, newDirection);
    }
  };

  return (
    <TableCell {...props}>
      {sortable ? (
        <TableSortLabel
          active={sortField === field}
          direction={sortField === field ? sortDirection : 'asc'}
          onClick={handleSort}
          sx={{ 
            fontWeight: 'bold',
            '&:hover': {
              color: 'primary.main'
            }
          }}
        >
          {label}
        </TableSortLabel>
      ) : (
        label
      )}
    </TableCell>
  );
};

export default SortableTableHeader; 